import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Waitlist.css';
import Logo from '../components/Logo';
import LoadingSpinner from '../components/LoadingSpinner';
import { optionalAuthHeaders } from '../utils/billingApi';
import { getContractApiUrl } from '../utils/apiUrls';

// Backend URL configuration
const BACKEND_URL = getContractApiUrl();


const Waitlist = () => {
    const { user, isAuthenticated, getAccessTokenSilently, getIdTokenClaims } = useAuth0();
    const navigate = useNavigate();
    const [userProfile, setUserProfile] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProfile = async () => {
            if (!isAuthenticated || !user?.email) {
                setLoading(false);
                return;
            }
            try {
                const headers = await optionalAuthHeaders({ getAccessTokenSilently, getIdTokenClaims });
                const response = await axios.get(
                    `${BACKEND_URL}/user/profile?email=${encodeURIComponent(user.email)}`,
                    { headers },
                );
                setUserProfile(response.data);
            } catch (err) {
                console.error('Error fetching profile in Waitlist:', err);
                // 404 / errors are not waitlist membership. Only a seeded
                // waitlist profile may offer "Complete Your Profile".
                setUserProfile(null);
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, [user, isAuthenticated, getAccessTokenSilently, getIdTokenClaims]);

    if (loading) return <LoadingSpinner />;

    if (userProfile && userProfile.profile_completed === false) {
        return (
            <div className="waitlist-container">
                <div className="waitlist-content">
                    <Logo size={80} />
                    <h1 style={{ marginTop: '30px' }}>Complete Your Profile</h1>
                    <p style={{ fontSize: '1.2rem', color: '#666', marginBottom: '30px' }}>
                        Welcome to KeyFlo! Please complete your profile to finish your setup.
                    </p>
                    <button
                        className="complete-profile-button"
                        onClick={() => navigate('/profile')}
                        style={{
                            padding: '12px 24px',
                            background: '#7fb069',
                            color: 'white',
                            border: 'none',
                            borderRadius: '30px',
                            fontSize: '1.1rem',
                            fontWeight: '600',
                            cursor: 'pointer'
                        }}
                    >
                        Complete Profile
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="waitlist-container">
            <div className="waitlist-content">
                <Logo size={80} />
                <h1 className="waitlist-headline">
                    Thank you for joining the KeyFlo Waitlist!
                </h1>

                <p className="waitlist-sub-headline">
                    We look forward to granting you full access to your AI-powered Real Estate Assistant very soon.
                </p>

                <p className="waitlist-text">
                    You'll receive an email as soon as you are moved off the waitlist.
                    <br />
                    <br />
                    In the meanwhile, you can learn more about KeyFlo here.
                </p>

                <div className="video-responsive">
                    <iframe
                        src="https://player.vimeo.com/video/1164812591?h=c98936c0b6&title=0&byline=0&portrait=0"
                        width="640"
                        height="360"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        title="KeyFlo Demo"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            borderRadius: '8px'
                        }}
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default Waitlist;
